module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.16127/images/hublet-ap1.svg"